import { PATHS } from "../../const"

interface BaseLink {
  title: string
  isDefault?: boolean
}

export interface ScreenLink extends BaseLink {
  link: string
  badge?: string
}

export interface ScreenGroup extends BaseLink {
  group: ScreenLink[]
}

export type ScreenLinks = (ScreenLink | ScreenGroup)[]

const policyLink = {
  title: `Policies`,
  link: PATHS.POLICIES,
}

const policyLookupLink = {
  title: `Policy lookup`,
  link: PATHS.POLICY_LOOKUP,
}

const referralsLink = {
  title: `Referrals`,
  link: PATHS.REFERRALS,
}

const claimsLink = {
  title: `Claims`,
  link: PATHS.CLAIMS,
}

export const BaseLinks: ScreenLinks = [policyLink, claimsLink]

export const AdminCarrierClaimsLinks: ScreenLinks = [...BaseLinks, policyLookupLink]

export const AdminCarrierLinks: ScreenLinks = [...AdminCarrierClaimsLinks, referralsLink]
